import classNames from "classnames"

import ErrorLayout from "modules/layout/error"

import MaintnanceImg from "assets/maintenance.gif"

import styles from "./styles.module.scss"
import { useTranslation } from "react-i18next"
const Maintenance: React.FC = () => {
  const { t } = useTranslation("translation")
  return (
    <ErrorLayout>
      <div>
        <div className={styles.container}>
          <div className={classNames(styles.imageContainer)}>
            <img src={MaintnanceImg} height="500px" alt="maintenance" />
          </div>
          <h1 className={classNames(styles.pageTitle, "display-heavy")}>
            {t("maintenance.title")}
          </h1>
          <p className={classNames(styles.pageSubtitle, "d")}>
            {t("maintenance.subtitle")}
          </p>
        </div>
      </div>
    </ErrorLayout>
  )
}

export default Maintenance
